import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descargas la guía PDF en tu teléfono o el de tu hijo.'
  }, {
    num: '2',
    text: 'Identificas los primeros síntomas de la crisis (calor, temblor o falta de aire).'
  }, {
    num: '3',
    text: 'Aplicas el Protocolo 5-5-5 y el Escaneo 3D para desactivar la alarma física en minutos.'
  }];
  return <section className="w-full bg-sage-light py-20 md:py-28 px-6 relative overflow-hidden" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-serif text-slate-900 text-center mb-16" data-id="element-108">
            Así de Simple Funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-109">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-sage-dark/30 z-0" data-id="element-110"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="relative z-10" data-id="element-111">
              <div className="flex flex-col items-center text-center" data-id="element-112">
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-sage-light mb-8 text-3xl font-serif font-bold text-sage-dark" data-id="element-113">
                  {step.num}
                </div>
                <p className="text-xl text-slate-800 font-medium leading-relaxed px-4" data-id="element-114">
                  {step.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}